export default __webpack_public_path__ + "static/media/Makro - C1.a75d22e8.jpg";